import React from 'react';
import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import UserBonusCheckpointsV2Render from '../Stepper';

export default function UserBonusCardCheckpointsV2Skeleton() {
  const { t } = useTranslation('bonus');

  return (
    <div className={styles.container}>
      <div className={styles.container__description}>
        <div className={skeleton.container}>
          <div className={skeleton.text} />
          <div className={skeleton.text} />
          <div className={skeleton.text} />
        </div>
      </div>
      <UserBonusCheckpointsV2Render checkpoints={[]} isLoading />
    </div>
  );
}
